function normalizeSocialProfileSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
}

function getPrefixes(value, minLength = 2) {
  const normalized = normalizeSocialProfileSearchText(value);
  const prefixes = [];

  for (let i = minLength; i <= normalized.length; i += 1) {
    prefixes.push(normalized.slice(0, i));
  }

  return prefixes;
}

function buildSocialProfileSearchPrefixes(authorName = "") {
  const normalizedName = normalizeSocialProfileSearchText(authorName);
  if (!normalizedName) return [];

  const tokens = normalizedName.split(" ").filter(Boolean);
  const prefixes = new Set();

  for (let tokenIndex = 0; tokenIndex < tokens.length; tokenIndex += 1) {
    const searchablePhrase = tokens.slice(tokenIndex).join(" ");
    getPrefixes(searchablePhrase).forEach((prefix) => prefixes.add(prefix));
  }

  return Array.from(prefixes);
}

function buildSocialProfileSearchFields(uid, authorName, latestPostAt) {
  const normalizedName = normalizeSocialProfileSearchText(authorName);

  return {
    uid,
    authorName,
    authorNameLower: normalizedName,
    searchPrefixes: buildSocialProfileSearchPrefixes(authorName),
    latestPostAt,
  };
}

export {
  buildSocialProfileSearchFields,
  buildSocialProfileSearchPrefixes,
  normalizeSocialProfileSearchText,
};
